import { render, staticRenderFns } from "./ErrorPopUpForDuplicate.vue?vue&type=template&id=477cc1ce&scoped=true&"
import script from "./ErrorPopUpForDuplicate.vue?vue&type=script&lang=js&"
export * from "./ErrorPopUpForDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPopUpForDuplicate.vue?vue&type=style&index=0&id=477cc1ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477cc1ce",
  null
  
)

export default component.exports